<script >
import TrackerDashboardFilters from "@/components/modules/tracker-dashboard/components/tracker-dashboard-filters.vue";
import DashboardSelector from "@/components/modules/new-dashboard/dashboard-selector.vue";

export default {
  components: {DashboardSelector, TrackerDashboardFilters},
  mounted() {
    this.$store.dispatch("REFRESH_TRACKER_DASHBOARD");
  },
  created: async function () {
    console.log(this.$route.params.lang);
    if (this.$route.params.lang) {
      await this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
  },
}
</script>

<template>
  <div style="background-color: #F5FAFD; position: relative;">
    <dashboard-selector v-if="$route.meta.isEmbed"></dashboard-selector>
    <tracker-dashboard-filters></tracker-dashboard-filters>
<router-view></router-view>
  </div>
</template>

<style scoped lang="scss">

</style>
